import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import App from './App.vue';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFastBackward, faFastForward, faCaretLeft, faCaretRight, faPlusCircle, faListAlt, faVolumeUp, faVolumeMute, faVolumeDown, faLink, faUnlink, faSync, faToggleOn, faToggleOff, faSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import PdfPreviewVue from './components/PdfPreview.vue';
import HomeVue from './components/Home.vue';
import ReceiverVue from './components/Receiver.vue';
import ProxyReceiverVue from './components/ProxyReceiver.vue'
import OBSControlVue from './components/OBSControl.vue';

const router = new VueRouter({
    routes: [
        { path: '/', component: HomeVue, props: { msg: "Hallo Welt!" } },
        { path: '/pdf', component: PdfPreviewVue },
        { name: 'receiver', path: '/receiver/', component: ReceiverVue },
        { name: 'proxyReceiver', path: '/proxyReceiver/:url/:proxy/:receiver', component: ProxyReceiverVue, props: true },
        { name: 'obsControl', path: '/obsControl', component: OBSControlVue },
    ]
});

library.add(faFastBackward, faFastForward, faCaretLeft, faCaretRight, faPlusCircle, faListAlt, faVolumeUp, faVolumeMute, faVolumeDown, faLink, faUnlink, faSync, faToggleOn, faToggleOff, faSquare)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = true;

new Vue({
    router: router,
    render: h => h(App)
}).$mount('#app');
